import React, { Fragment, useEffect, useState } from 'react';
import { LogOut } from 'react-feather';

const UserMenu = () => {
    const [profile, setProfile] = useState('');

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('full_name');
        localStorage.removeItem('email');
        localStorage.removeItem('first_time_login');
        localStorage.removeItem('position');
        localStorage.removeItem('role');

        window.location.reload();
    };

    useEffect(() => {
        setProfile((localStorage.getItem('full_name') || '...').charAt(0).toUpperCase());
    }, []);

    return (
        <Fragment>
            <style>{`
    .headerLogoutButton {
        height: 42px;
        min-width: 112px;
        border-radius: 14px;
        border: 1px solid #FECACA;
        background: #FEF2F2;
        color: #B91C1C;
        padding: 0 14px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 950;
        cursor: pointer;
        box-shadow: 0 8px 20px rgba(185, 28, 28, 0.08);
        transition: 0.16s ease;
        line-height: 1;
        white-space: nowrap;
        margin: 0 !important;
        vertical-align: middle;
    }

    .headerLogoutButton:hover {
        background: #FEE2E2;
        border-color: #FCA5A5;
        color: #991B1B;
        transform: translateY(-1px);
        box-shadow: 0 12px 26px rgba(185, 28, 28, 0.12);
    }

    .headerLogoutButton svg {
        width: 17px;
        height: 17px;
        flex: 0 0 auto;
        display: block;
    }

    .headerLogoutButton span {
        display: inline-flex;
        align-items: center;
    }

    @media (max-width: 991px) {
        .headerLogoutButton {
            height: 40px;
            min-width: 94px;
            padding: 0 11px !important;
            border-radius: 13px;
            font-size: 12px;
            gap: 6px;
            margin: 0 !important;
        }

        .headerLogoutButton svg {
            width: 16px;
            height: 16px;
        }

        .headerLogoutButton span {
            display: inline-flex;
        }
    }

    @media (max-width: 420px) {
        .headerLogoutButton {
            min-width: 84px;
            height: 38px;
            padding: 0 9px !important;
            font-size: 11.5px;
            gap: 5px;
            border-radius: 12px;
        }

        .headerLogoutButton svg {
            width: 15px;
            height: 15px;
        }
    }
`}</style>

            <button
                type="button"
                className="headerLogoutButton"
                onClick={logout}
                title="Log out"
            >
                <LogOut size={16} />
                <span>Log out</span>
            </button>
        </Fragment>
    );
};

export default UserMenu;